import * as React from 'react';

import { CollapsibleSection } from 'common/components';
import { PK } from 'common/types';
import { TAGGING_CONTENT_TYPES } from 'modules/tagging/consts';
import { TagsForm } from 'modules/tagging/components';
import { useProgramTags, useProgramTagsUpdate } from '../queries';
import { programsTagsValidationSchema } from '../consts';
import { extractFirstValue, extractValues } from 'common/utils/tags';

type Props = {
  setIsTags: (isTags: boolean) => void;
  pk?: PK;
};

const ProgramTagsPicker = ({ pk, setIsTags }: Props) => {
  const { data: programTagData } = useProgramTags(pk);
  const { mutate: updateProgram, isSuccess, isLoading, isError } = useProgramTagsUpdate();
  const isTags =
    programTagData?.category &&
    Array.isArray(programTagData?.category) &&
    programTagData?.category.length > 0;

  React.useEffect(() => {
    setIsTags(!!isTags);
  }, [isTags, setIsTags]);

  const saveTags = (values: any) => {
    const payload: Record<string, any> = {};

    const category = extractValues(values.category);
    if (category) payload.category = category;

    const gender = extractFirstValue(values.gender);
    if (gender) payload.gender = gender;

    payload.pk = pk;

    updateProgram(payload as any);
  };

  return (
    <>
      <CollapsibleSection
        title="Add tags"
        saveStatus={{ isSuccess, isLoading, isError }}
        disabled={!pk}
        divider={false}
      >
        <TagsForm
          validationSchema={programsTagsValidationSchema}
          contentType={TAGGING_CONTENT_TYPES.LIFESTYLE_PROGRAM}
          defaultValues={programTagData}
          onSubmit={saveTags}
          isSubmitting={isLoading}
        />
      </CollapsibleSection>
    </>
  );
};

export default ProgramTagsPicker;
